export const VIEW_INFO_POPUP = 'InfoPopup'
export const VIEW_SINGLE_ASSIGN_POPUP = 'SingleAssignPopup'
export const VIEW_ORGANIZATION_ADMIN_REMOVAL_POPUP = 'OrganizationAdminRemovalPopup'
export const VIEW_MEMBERSHIP_PICKER_MODAL = 'MembershipsPickerModal'
